<template>
    <div v-loading="loading" class="container-fluid py-4 mt-6 page-shell">
        <div class="row g-3">
            <div v-if="!info.cancelType" class="col-12">
                <div class="insured-action-bar soft-card">
                    <div class="insured-action-bar__group">
                        <button type="button" class="action-btn action-btn--info" @click="openOpModal('updateInfo')">
                            <i class="bi bi-pencil-square" aria-hidden="true"></i>
                            <span>{{ $t("insuredUpdateInfo") }}</span>
                        </button>
                        <button type="button" class="action-btn action-btn--warning" @click="openOpModal('programChange')">
                            <i class="bi bi-arrow-left-right" aria-hidden="true"></i>
                            <span>{{ $t("insuredProgramChange") }}</span>
                        </button>
                    </div>
                    <div class="insured-action-bar__divider" aria-hidden="true"></div>
                    <button type="button" class="action-btn action-btn--danger" @click="openOpModal('terminate')">
                        <i class="bi bi-x-circle" aria-hidden="true"></i>
                        <span>{{ $t("insuredTerminate") }}</span>
                    </button>
                </div>
            </div>
            <div class="col-12">
                <insured-info :info="info" :data-table="dataTable" :claim-data-table="claimDataTable" :data-family="dataFamily"
                    @get-info="getTableInfo" @get-req-table="getTable" @open-op-modal="openOpModal"></insured-info>
            </div>
        </div>
    </div>
    <request-operation-modal
        v-model="opModalVisible"
        :op-type="opModalType"
        :policy-id="info.policyId"
        :initial-selected-insured="selectedInsuredForOp || info"
        @success="onOperationSuccess"
    />
    <el-dialog v-model="infoDialogVis" :title="$t('insuredChanges')" modal-class="modal-class" width="820px"
        :destroy-on-close="true" align-center>
        <ChangeInfoDialog :info="infoDialogData" :change-data="editInsured" @custom-event="closeInfoDialog" />
    </el-dialog>
</template>
<script>
import { getCardId } from "@/project/Source/routes";

import InsuredInfo from "./components/InsuredInfo.vue";
import ChangeInfoDialog from "../Global/Modals/ChangeInfoDialog.vue";
import RequestOperationModal from "@/project/Request/components/RequestOperationModal.vue";
import Source from "../Source/claim.js";

export default {
    components: { InsuredInfo, ChangeInfoDialog, RequestOperationModal },
    data() {
        return {
            opModalVisible: false,
            opModalType: "updateInfo",
            selectedInsuredForOp: null,
            loading: false,
            dataTable: null,
            claimDataTable: null,
            infoDialogData: {},
            infoDialogVis: false,
            dataFamily: [],
            info: { dob: 'null', startDate: 'null' }
        };
    },
    created() {
        this.getInfo();
        this.getTable();
    },
    methods: {
        toggleWin() {
            this.$router.push("/claim");
        },
        openOpModal(type, targetInsured = null) {
            this.opModalType = type;
            this.selectedInsuredForOp = targetInsured || this.info;
            this.opModalVisible = true;
        },
        onOperationSuccess() {
            this.getInfo();
            this.getTable();
        },
        getTableInfo(id) {
            const data = {
                "id": id,
                "requestCorrelationId": Date.now().toString(36) + Math.random().toString(36).substr(2)
            };
            Source.AccountRequestById(data).then((response) => {
                this.infoDialogData = response.data.data[0];
                this.infoDialogVis = true;
            });
        },
        closeInfoDialog() {
            this.infoDialogVis = false;
        },
        getInfo() {
            this.loading = true;
            const data = {
                id: getCardId(this.$route),
                requestCorrelationId: "string"
            };
            Source.PolicyCardByCard(data).then((response) => {
                this.info = response.data.data[0] || {};
            }).catch((err) => {
                console.error("PolicyCardByCard error:", err);
            }).finally(() => {
                this.loading = false;
            });
        },
        getTable() {
            const data = {
                id: getCardId(this.$route),
                requestCorrelationId: "string"
            };
            Source.AccountRequestByCard(data).then((response) => {
                this.dataTable = response.data.data || [];
            }).catch((err) => {
                console.error("AccountRequestByCard error:", err);
            }).finally(() => {
                this.loading = false;
            });
        },
    }
};
</script>
